// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"4128121b","539":"3ba70526","547":"46f4d906"}[chunkId] + ".chunk.js";
};